import {
  signature_styles_default
} from "./chunk.RV3XZRC2.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  e2,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/signature/signature.ts
import { t } from "i18next";
var FadvSignature = class extends s {
  constructor() {
    super(...arguments);
    this.readonly = false;
    this.drawSignature = false;
    this.drawOnly = false;
    this.defaultDisclaimer = t("components:signature.disclaimer");
    this.pointBuffer = [];
    this.currentPoint = { x: 0, y: 0 };
  }
  handleDrawSignatureChange() {
    if (!this.drawSignatureCheckbox)
      return;
    this.drawSignatureCheckbox.checked = this.drawSignature;
    this.handleSignatureTypeChange();
  }
  handleDrawSignatureCheckChange() {
    if (!this.drawSignatureCheckbox)
      return;
    this.drawSignature = this.drawSignatureCheckbox.checked;
    this.handleSignatureTypeChange();
  }
  handleSignatureTypeChange() {
    if (!this.drawSignature) {
      this.handlePrefilledSignatureChange();
    } else {
      this.clearSignature();
    }
  }
  handlePrefilledSignatureChange() {
    if (this.drawSignature)
      return;
    if (!this.canvas)
      return;
    const context = this.canvas.getContext("2d");
    if (!context)
      return;
    this.clearCanvas(context);
    if (!this.prefilledSignature)
      return;
    let fontSize = 30;
    const minFontSize = 18;
    context.fillStyle = "#000";
    context.textAlign = "center";
    context.font = `${fontSize}px "Pacifico", cursive`;
    function reduceFontSize(ctx, text) {
      let textWidth = ctx.measureText(text);
      while (fontSize > minFontSize && textWidth.width > ctx.canvas.width) {
        ctx.font = `${--fontSize}px "Pacifico", cursive`;
        textWidth = ctx.measureText(text);
      }
    }
    reduceFontSize(context, this.prefilledSignature);
    const padding = 5;
    if (fontSize <= minFontSize) {
      fontSize = 30;
      context.font = `${fontSize}px "Pacifico", cursive`;
      const signatureParts = this.prefilledSignature.split(" ");
      const longestPart = signatureParts.reduce((acc, next) => next.length > acc.length ? next : acc, "");
      reduceFontSize(context, longestPart);
      const offset = (this.canvas.height - fontSize * signatureParts.length) / 2 - padding;
      signatureParts.forEach((part, index) => {
        const yPosition = offset + fontSize * index;
        context.fillText(part, this.canvas.width / 2, yPosition + fontSize, this.canvas.width - padding);
      });
    } else {
      context.fillText(this.prefilledSignature, this.canvas.width / 2, this.canvas.height / 2 + fontSize / 2 - padding, this.canvas.width - padding);
    }
    this.emitCanvasValue();
  }
  clearSignature() {
    const context = this.canvas.getContext("2d");
    if (!context)
      return;
    this.signatureClearButton.disabled = true;
    this.clearCanvas(context);
  }
  saveSignature() {
    var _a;
    return (_a = this.canvas) == null ? void 0 : _a.toDataURL();
  }
  loadSignature(data) {
    const image = new Image();
    image.src = data;
    this.drawSignature = false;
    this.drawSignatureCheckbox.checked = false;
    this.clearSignature();
    image.onload = () => {
      const context = this.canvas.getContext("2d");
      context.drawImage(image, 0, 0);
      this.emitCanvasValue();
    };
  }
  async connectedCallback() {
    super.connectedCallback();
    this.resizeObserver = new ResizeObserver(() => {
      this.canvas.width = this.canvasContainer.clientWidth;
      this.bufferCanvas.width = this.canvasContainer.clientWidth;
      this.handleDrawSignatureCheckChange();
    });
    await this.updateComplete;
    if (this.drawOnly) {
      this.drawSignature = true;
    }
    this.resizeObserver.observe(this);
    this.canvas.width = this.canvasContainer.clientWidth;
    this.bufferCanvas.width = this.canvasContainer.clientWidth;
    this.drawing = this.drawing.bind(this);
    this.drawSignatureCheckbox.checked = this.drawSignature;
    this.handleDrawSignatureCheckChange();
    const font = "1rem Pacifico";
    if (!document.fonts.check(font)) {
      await document.fonts.load(font);
    }
    this.handlePrefilledSignatureChange();
  }
  clearCanvas(context) {
    if (!context)
      return;
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    this.emitCanvasValue();
  }
  handleBufferMove(event) {
    if (!this.drawSignature)
      return;
    this.currentPoint = this.getRelativeCoordinates(event);
  }
  drawing(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.signatureClearButton.disabled) {
      this.signatureClearButton.disabled = false;
    }
    this.pointBuffer.push(this.currentPoint);
    const context = this.bufferCanvas.getContext("2d");
    const start = this.pointBuffer[0];
    if (this.pointBuffer.length < 3) {
      context.beginPath();
      context.arc(start.x, start.y, context.lineWidth / 2, 0, Math.PI * 2, true);
      context.fill();
      context.closePath();
      return;
    }
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    context.beginPath();
    context.moveTo(start.x, start.y);
    for (let index = 1; index < this.pointBuffer.length - 2; index++) {
      const point = this.pointBuffer[index];
      const nextPoint = this.pointBuffer[index + 1];
      const x = (point.x + nextPoint.x) / 2;
      const y = (point.y + nextPoint.y) / 2;
      context.quadraticCurveTo(point.x, point.y, x, y);
    }
    const penultimate = this.pointBuffer[this.pointBuffer.length - 2];
    const last = this.pointBuffer[this.pointBuffer.length - 1];
    context.quadraticCurveTo(penultimate.x, penultimate.y, last.x, last.y);
    context.stroke();
    context.closePath();
  }
  enableDrawing(event) {
    if (!this.drawSignature)
      return;
    this.bufferCanvas.addEventListener("mousemove", this.drawing);
    this.bufferCanvas.addEventListener("touchmove", this.drawing);
    const point = this.getRelativeCoordinates(event);
    const context = this.bufferCanvas.getContext("2d");
    context.lineWidth = 3;
    context.fillStyle = "#000";
    context.strokeStyle = "#000";
    context.lineCap = "round";
    context.lineJoin = "round";
    this.currentPoint = point;
    this.pointBuffer.push(point);
  }
  disableDrawing() {
    if (!this.drawSignature)
      return;
    this.bufferCanvas.removeEventListener("mousemove", this.drawing);
    this.bufferCanvas.removeEventListener("touchmove", this.drawing);
    const context = this.canvas.getContext("2d");
    const buffer = this.bufferCanvas.getContext("2d");
    context.drawImage(this.bufferCanvas, 0, 0);
    buffer.clearRect(0, 0, this.bufferCanvas.width, this.bufferCanvas.height);
    this.pointBuffer = [];
    this.emitCanvasValue();
  }
  getRelativeCoordinates(event) {
    const element = event.target;
    const boundingBox = element.getBoundingClientRect();
    let x;
    let y;
    if (event.type.indexOf("touch") < 0) {
      const e3 = event;
      x = e3.clientX;
      y = e3.clientY;
    } else {
      const e3 = event;
      x = e3.touches[0].clientX;
      y = e3.touches[0].clientY;
    }
    return { x: x - boundingBox.x, y: y - boundingBox.y };
  }
  emitCanvasValue() {
    if (this.drawSignature && this.signatureClearButton.disabled || !this.drawSignature && !this.prefilledSignature) {
      emit(this, "signature-change", { detail: { image: void 0 } });
    } else {
      emit(this, "signature-change", { detail: { image: this.canvas.toDataURL() } });
    }
  }
  render() {
    return $`<div class=${o({
      signature: true,
      "signature--readonly": this.readonly,
      "signature--draw": this.drawSignature,
      "signature--draw-only": this.drawOnly
    })} ><div class="signature__label-container"><div class="signature__label"><fadv-typography type="label-medium">${this.label || t("components:signature.signature")}</fadv-typography></div><div class="signature__draw-signature"><fadv-checkbox @sl-change=${this.handleDrawSignatureCheckChange}>${t("components:signature.drawSignature")}</fadv-checkbox></div></div><div class="signature__container"><canvas height="150" class="signature__canvas"></canvas><canvas height="150" class="signature__buffer" @mousemove=${this.handleBufferMove} @touchmove=${this.handleBufferMove} @mousedown=${this.enableDrawing} @mouseup=${this.disableDrawing} @touchstart=${this.enableDrawing} @touchend=${this.disableDrawing} ></canvas><fadv-button disabled outline pill class="signature__clear" @click=${this.clearSignature}>${t("components:common.clear")}</fadv-button></div><div class="signature__disclaimer"><fadv-typography type="paragraph-x-small">${this.useDefaultDisclaimer ? this.defaultDisclaimer : this.disclaimer}</fadv-typography></div></div>`;
  }
};
FadvSignature.styles = signature_styles_default;
__decorateClass([
  e({ type: Boolean })
], FadvSignature.prototype, "readonly", 2);
__decorateClass([
  e({ attribute: "prefilled-signature" })
], FadvSignature.prototype, "prefilledSignature", 2);
__decorateClass([
  e({ type: Boolean, reflect: true, attribute: "draw-signature" })
], FadvSignature.prototype, "drawSignature", 2);
__decorateClass([
  e({ type: Boolean, reflect: true, attribute: "draw-only" })
], FadvSignature.prototype, "drawOnly", 2);
__decorateClass([
  e()
], FadvSignature.prototype, "label", 2);
__decorateClass([
  e()
], FadvSignature.prototype, "disclaimer", 2);
__decorateClass([
  e({ type: Boolean })
], FadvSignature.prototype, "useDefaultDisclaimer", 2);
__decorateClass([
  i(".signature__container")
], FadvSignature.prototype, "canvasContainer", 2);
__decorateClass([
  i(".signature__canvas")
], FadvSignature.prototype, "canvas", 2);
__decorateClass([
  i(".signature__buffer")
], FadvSignature.prototype, "bufferCanvas", 2);
__decorateClass([
  i("fadv-checkbox")
], FadvSignature.prototype, "drawSignatureCheckbox", 2);
__decorateClass([
  i(".signature__clear")
], FadvSignature.prototype, "signatureClearButton", 2);
__decorateClass([
  watch("drawSignature")
], FadvSignature.prototype, "handleDrawSignatureChange", 1);
__decorateClass([
  watch("prefilledSignature")
], FadvSignature.prototype, "handlePrefilledSignatureChange", 1);
__decorateClass([
  e2({ capture: false })
], FadvSignature.prototype, "handleBufferMove", 1);
FadvSignature = __decorateClass([
  n("fadv-signature")
], FadvSignature);

export {
  FadvSignature
};
